import { Component, Input } from '@angular/core';
import { SignalsProvider } from '../../providers/signals/signals';
import { IonicPage, NavController, LoadingController, ToastController, ModalController } from 'ionic-angular';
import { LiveSignal } from '../../models/Signal';
import { Subscription } from 'rxjs/Subscription';

/**
 * Generated class for the SignalsListComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'signals-list',
    templateUrl: 'signals-list.html'
})
export class SignalsListComponent {

    @Input('list') list: LiveSignal[] = null;
    @Input('stocks') stocks: boolean = false;

    signals: LiveSignal[] = [];
    allSignals: LiveSignal[] = [];
    hasLoaded: boolean = false;

    subscription: Subscription;

    constructor(
        public signalsCtrl: SignalsProvider,
        public loadingCtrl: LoadingController,
        public toastCtrl: ToastController
    ) {

    }

    ngOnInit(){
        if(this.list){
            this.allSignals = this.list;
            this.signals = [];
            this.loadMoreSignals();
            this.hasLoaded = true;
        }else{
            let loader = this.loadingCtrl.create();
            loader.present();
            this.signalsCtrl.viewingSignals = true;
            this.signalsCtrl.clearCount();
    
            this.subscription = this.signalsCtrl.getAllSignals(this.stocks).subscribe(signals => {
                this.allSignals = signals;
                this.signals = [];
                this.loadMoreSignals();
                this.hasLoaded = true;
                loader.dismiss();
            }, error => {
                this.toastCtrl.create({ message: error, duration: 3000 }).present();
                loader.dismiss();
            })
        }
    }

    getMoreItems(infiniteScroll) {
        this.loadMoreSignals();
        infiniteScroll.complete();
    }
    loadMoreSignals() {
        let start = this.signals.length;
        let end = start + 14;

        if (end >= this.allSignals.length) {
            end = this.allSignals.length - 1;
        }
        for (let i = start; i <= end; i++) {
            this.signals.push(this.allSignals[i]);
        }
    }
    getMoreItemsButton(event) {
        this.loadMoreSignals();
    }


    ionViewDidLeave() {
        if (this.subscription) this.subscription.unsubscribe();
        this.signalsCtrl.viewingSignals = false;
    }

}



// WEBPACK FOOTER //
// ./src/components/signals-list/signals-list.ts